const knowledgeRouter = {
  path: '/knowledge',
  name: 'knowledge',
  component: () => import('@/modules/web/modules/knowledge/views/KnowledgeView.vue')
}

export { knowledgeRouter }
